/* import __COLOCATED_TEMPLATE__ from './lsg-reviews-stars.hbs'; */
import { A } from '@ember/array';
import { equal } from '@ember/object/computed';
import { computed } from '@ember/object';
import Component from '@ember/component';

/**
 * Array of text for the most common review star lables used.
 *
 * @type {string[]}
 */
export const LSG_REVIEW_STARS__STAR_LABELS = [
  'Poor',
  'Below Average',
  'Average',
  'Good',
  'Exceptional'
];

/**
 * @type {Object}     Common styles for the stars.
 */
export const LSG_REVIEW_STARS__STAR_STYLES = {
  LARGE_AND_BLACK: 'large-and-black',
  SMALL_AND_YELLOW: 'small-and-yellow'
};

export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'span',
  classNames: ['LSG-c-reviews-stars'],
  classNameBindings: [
    'isAllowSelection:LSG-c-reviews-stars--selectable',
    '_isLargeAndBlack:LSG-c-reviews-stars--large-and-black'
  ],

  /**
   * @param {Number=}    The actual review.  Should be less than the maximum.
   */
  actualReview: 0,

  /**
   * @param {Number=}    The maximum number of stars
   */
  maxReview: 5,

  /**
   * This will return a param of the index of the star clicked, 0-based.
   *
   * @param {Function=}   Handler for what to do if user clicks on a star.
   */
  handleStarClick: function(starIndexClicked) {},

  /**
   * e.g. ['poor', 'average', 'good']  Each element in the array corresponds to a star value, so a star rating
   * of 1 would show 'poor', 2 would should 'average' and etc. in this example.
   *
   * @param {Array<String>}     You can pass in the rate to allow rating text to show up next to the stars.
   */
  ratingTextLabels: [],

  /**
   * @param {Boolean=}    If this is true, the handleStarClick will be called when user clicks and UI will update to look clickable
   */
  isAllowSelection: false,

  /**
   * Select a common style for the star component
   *
   * @param {String}      Of type LSG_REVIEW_STARS__STAR_STYLES.*
   */
  starsStyle: LSG_REVIEW_STARS__STAR_STYLES.SMALL_AND_YELLOW,

  /**
   * @type {Boolean}      True if we have a rating text to show.
   */
  _hasRatingText: computed('ratingTextLabels.length', function() {
    return this.get('ratingTextLabels.length');
  }),

  /**
   * @type {Boolean}      True if the style is large and black
   */
  _isLargeAndBlack: equal('starsStyle', LSG_REVIEW_STARS__STAR_STYLES.LARGE_AND_BLACK),

  /**
   * @type {String}       The rating text for the star rating as passed in by the caller.
   */
  _ratingText: computed('ratingTextLabels.length', 'actualReview', function() {
    let ratingTextLabels = this.get('ratingTextLabels'),
      actualReview = this.get('actualReview');
    if (!ratingTextLabels.get('length') || actualReview < 1) {
      return '';
    }

    return ratingTextLabels[actualReview - 1];
  }),

  /**
   * The stars to render for the actual review.
   *
   * @type {Ember.MutableArray}
   */
  _starsToRender: computed('actualReview', 'isAllowSelection', 'maxReview', function() {
    let starsToRender = A(),
      actualReview = this.get('actualReview'),
      roundedReviewScore = Math.round(actualReview);

    if (!actualReview) {
      return starsToRender;
    }

    for (let i = 1; i <= roundedReviewScore; i++) {
      starsToRender.pushObject(i);
    }

    return starsToRender;
  }),

  /**
   * The star border to render up to the maximum
   *
   * @type {Ember.MutableArray}
   */
  _starBordersToRender: computed('maxReview', 'actualReview', function() {
    let starsToRender = A(),
      actualReview = this.get('actualReview'),
      maxReview = this.get('maxReview');

    for (let i = Math.round(actualReview); i < maxReview; i++) {
      starsToRender.pushObject(i);
    }

    return starsToRender;
  }),

  actions: {
    /**
     * Called when user clicks on a star that has ALREADY been selected
     *
     * @param {Number} starIndex
     */
    onStarClickSelected: function(starIndex) {
      if (!this.get('isAllowSelection')) {
        return;
      }

      this.handleStarClick(starIndex);
    },

    /**
     * Called when user clicks on a star that has NOT been selected
     *
     * @param {Number} starIndex
     */
    onStarClickUnselected: function(starIndex) {
      if (!this.get('isAllowSelection')) {
        return;
      }

      let actualReview = this.get('actualReview');
      this.handleStarClick(actualReview + starIndex);
    }
  }
});
